<style scoped>
  .title-blue {
    background: #4187ff;
    color: white;
    height: 50px;
    text-align: left;
    /*align-items: center;
    display: flex;*/
  }

  .title-blue > div {
    padding: 13px 20px 10px 20px;
  }

  .title {
    text-align: left;
    padding: 10px 10px 15px 10px;
    color: rgb(85, 143, 247);
    font-weight: 500;
    border-bottom: 1px solid rgb(85, 143, 247);

  }

  .color-red {
    color: red;
  }

  .list {
    font-weight: 500;
    padding: 10px 10px 15px 10px;
    text-align: left;
  }
</style>

<template>
  <div>
    <van-row>
      <van-col span="24" class="title-blue">
        <div>
          <span>{{detectionDep.detectionDepName}}</span>
          <span style="float: right" @click="showBookItemList">{{bookItem.name}}
          <van-icon style="float: right;padding-top: 3px" name="arrow-down"/>
        </span>

        </div>
      </van-col>
    </van-row>

    <van-row class="title">
      <van-col span="6">患者</van-col>
      <van-col span="6">执行状态</van-col>
      <van-col span="6">上/下午</van-col>
      <van-col span="6">预约时间段</van-col>
    </van-row>

    <template >
      <van-row v-for="(item,index) in departmentDetailList" :key="index" class="list">
        <van-col span="6">{{item.name}}</van-col>
        <van-col span="6" :class="{'color-red':item.executed==='未执行'}">{{item.exeStatus}}</van-col>
        <van-col span="6">{{item.timeSlot}}</van-col>
        <van-col span="6">{{item.time}}</van-col>
      </van-row>
    </template>

    <van-overlay :show="show" @click="show = false">
      <van-row>
        <van-col span="24" style="position:fixed; bottom:0">
          <van-picker
            v-show="show"
            title="预约项目"
            :default-index=pickerIndex
            :columns="bookItemList"
            value-key="name"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
          />
        </van-col>
      </van-row>
    </van-overlay>

  </div>
</template>

<script>
  import api from "@/axios/api";
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: "departmentDetail",
    computed: {
      ...mapGetters(["token"])
    },
    watch: {
      token: {
        immediate: true,
        handler: function (val) {
          if (val) {
            this.getPatientDetailList();
          }
        }
      }
    },
    data() {
      return {
        show: false,
        //时间
        bookTime: this.$route.query.bookTime,
        //医技科室
        detectionDep: {
          detectionDepId: this.$route.query.detectionDepId,
          detectionDepName: this.$route.query.detectionDepName,
          precise: this.$route.query.precise
        },
        //预约项目
        bookItem: {
          id: this.$route.query.bookItemId,
          name: this.$route.query.bookItemName

        },
        bookItemList: [],
        departmentDetailList: [
          {
            name: '',
            exeStatus: '',
            timeSlot: '',
            time: ''
          }
        ],
        //选择框默认选中项索引
        pickerIndex: 0
      }
    },
    created: function () {
      this.getPatientDetailList();
    },
    methods: {
      onConfirm(value, index) {
        this.bookItem.name = value.name;
        this.bookItem.id = value.id;
        this.getPatientDetailList();
        this.pickerIndex = index;
        this.show = false;
      },
      onChange(picker, value, index) {
        this.bookItem.name = value.name;
        this.bookItem.id = value.id;
        this.getPatientDetailList();
        this.pickerIndex = index;
        this.show = false;
      },
      onCancel() {
        this.show = false;
      },
      showBookItemList() {
        this.show = true;
        this.getAllBookItem();
      },
      //获取该医技科室下所有预约项目
      getAllBookItem() {
        this.bookItemList = []
        api.getAllBookItem(this.detectionDep.detectionDepId).then(res => {
          this.bookItemList = res.bookItemList;
        });
      },
      //获取科室别详情数据
      //String bookTime , String bookItemId , int precise
      getPatientDetailList() {
        this.departmentDetailList = []
        api.getPatientDetailList(this.detectionDep.detectionDepId, this.bookTime, this.bookItem.id, this.detectionDep.precise).then(res => {
          this.departmentDetailList = res.list;
        });

      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/hospital-admin/pages/department-detail.vue